import { render, staticRenderFns } from "./CalendarCallback.vue?vue&type=template&id=624bf5b3"
import script from "./CalendarCallback.vue?vue&type=script&lang=js"
export * from "./CalendarCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports